import React from 'react'

export default ({columns, className, children}) =>
  <table className={className}>
    <thead>
      <tr>
        {columns.map((col, i) =>
          <th key={i}>{col}</th>
        )}
      </tr>
    </thead>
    <tbody>
      {(React.Children.toArray(children).filter(c => !!c).length < 1) &&
        <tr className='no-data'><td colSpan={columns.length}>No data</td></tr>
      }
      {children}
    </tbody>
  </table>



// WEBPACK FOOTER //
// ./app/components/Table.js